import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";
import React, { useState } from "react";
import OfferImg1 from "../../assets/Yoga_Sand_Stone.png";
import offerDescription from "../OfferDescription.jsx";
import {Kachel4} from "../Offer";
import SEO from "../SEO";


export default function Firmenyoga() {
  const [matches, setMatches] = useState(window.innerWidth);
  window.addEventListener("resize", checkSize);

  function checkSize() {
    setMatches(window.innerWidth);
  }
  return (
    <>
      <SEO
          title="Firmenyoga in Landsberg am Lech | Yoga für Mitarbeiter"
          description="Firmenyoga in Landsberg am Lech für Unternehmen, öffentliche und soziale Einrichtungen. Yoga für Mitarbeiter, bewegte Pausen und individuelle Angebote."
      />
      <section className="offerSec">
        <h4 className="introHeader">{offerDescription[0].title}</h4>
        <div className="intro">{offerDescription[0].body}</div>
        <h2 id="offer">Angebot</h2>

          <Row lg={1} sm={12} className="g-4">
            <Col>
              <Card className="cardOfferHeight">
                <Card.Body>
                  <Card.Title>{Kachel4.header2}</Card.Title>
                  <br></br>
                  <Card.Text>
                    {Kachel4.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            {matches > 768 && (
            <Col>
              <Card.Img className="cardImageDetail" variant="top" src={OfferImg1} />
            </Col>
            )}
          </Row>
        <LinkContainer to={`/`}>
          <Button>Zurück</Button>
        </LinkContainer>
      </section>
    </>
  );
}
